import { components } from "./apex-client-gen";

export type GetBankRelationshipResponse =
  components["schemas"]["GetMyBankRelationshipsResponse"];

export type MakeDepositsResponse =
  components["schemas"]["MakeDepositsResponse"];
export type MakeDepositsRequest =
  components["schemas"]["CreateDepositRequest-Input"];

export type MakeWithdrawalsResponse =
  components["schemas"]["MakeWithdrawalsResponse"];
export type MakeWithdrawalsRequest =
  components["schemas"]["CreateWithdrawalRequest-Input"];

export const IRA_ACCOUNT_TYPES = new Set([
  "RETIREMENT_TRADITIONAL",
  "RETIREMENT_ROTH",
  "RETIREMENT_ROLLOVER",
]);

// firm-data names IRAs in its own vocabulary (see shared-utils plaid-account).
const FIRM_DATA_IRA_TYPES = new Set(["traditional_ira", "roth_ira", "sep_ira", "simple_ira"]);

/** An IRA in either Apex's or firm-data's account-type vocabulary. */
export const isIraAccountType = (type?: string | null): boolean =>
  Boolean(type) &&
  (IRA_ACCOUNT_TYPES.has(type as string) ||
    FIRM_DATA_IRA_TYPES.has((type as string).trim().toLowerCase()));
